import { Flex, Paper, Title } from '@mantine/core';
import { FullLogoIcon } from '@zenos/front-end-ui-icons';
import { GoogleSignInButton } from './GoogleSignInButton';

export const LoginPage = () => {
  return (
    <Flex justify="center" align="center" style={{ height: '100vh' }}>
      <Paper withBorder p="xl" shadow="lg">
        <Title style={{ textAlign: 'center' }} pb="lg" order={4}>
          <FullLogoIcon />
        </Title>
        <GoogleSignInButton />
      </Paper>
    </Flex>
  );
};
